/* HorrorBoard — cart drawer v2 add-ons (a11y + summary toggle).
   Presentation-layer only: it never touches cart state, variants or checkout;
   it observes the drawer that horrorboard.js already renders. */
(function(){
  if(window.__hbCartA11y) return; window.__hbCartA11y = 1;
  var $ = function(id){ return document.getElementById(id); };
  var lastFocus = null;

  function drawerOpen(){ var d = $('cartDrawer'); return !!d && d.classList.contains('open'); }

  /* keep the order summary in sync with the item list horrorboard.js renders */
  function syncSummary(){
    var sum = $('cdSummary'), foot = $('cartFoot');
    if(!sum || !foot) return;
    var visible = foot.style.display !== 'none';
    sum.style.display = visible ? '' : 'none';
  }

  /* body scroll lock while the drawer is open (keeps the page behind still) */
  var lockedY = 0, locked = false;
  function lockBody(){
    if(locked) return; locked = true;
    lockedY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-lockedY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockBody(){
    if(!locked) return; locked = false;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedY);
  }

  function focusables(){
    var d = $('cartDrawer'); if(!d) return [];
    return Array.prototype.filter.call(
      d.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function(el){ return !el.disabled && el.offsetParent !== null; }
    );
  }

  document.addEventListener('keydown', function(e){
    if(!drawerOpen()) return;
    if(e.key === 'Escape'){
      e.preventDefault();
      var c = $('cartClose'); if(c) c.click();
      return;
    }
    if(e.key === 'Tab'){
      var f = focusables(); if(!f.length) return;
      var first = f[0], last = f[f.length-1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      else if(!$('cartDrawer').contains(document.activeElement)){ e.preventDefault(); first.focus(); }
    }
  });

  /* react to open/close + re-render without duplicating any cart logic */
  function boot(){
    var d = $('cartDrawer'); if(!d) return;
    syncSummary();
    new MutationObserver(function(){
      if(drawerOpen()){
        if(!locked){
          lastFocus = document.activeElement;
          lockBody();
          setTimeout(function(){ var c = $('cartClose'); if(c) c.focus(); }, 60);
        }
      } else if(locked){
        unlockBody();
        if(lastFocus && lastFocus.focus){ try{ lastFocus.focus(); }catch(err){} }
      }
      syncSummary();
    }).observe(d, {attributes:true, attributeFilter:['class']});

    var foot = $('cartFoot');
    if(foot){ new MutationObserver(syncSummary).observe(foot, {attributes:true, attributeFilter:['style']}); }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
